import {AuthErrorNames} from '@/services';

// Dev/testing-only default so local sign-ins don't require typing a phone
// number every time. Never used outside `isDevelopment`.
export const DEV_PHONE_NUMBER = '+16021158886';

const TOAST = {
  EmptySignInPassword: {
    TITLE: 'Password Required',
    DETAILS: 'To sign in, please enter your password.',
  },
  NOT_AUTHORIZED: {
    TITLE: 'User not authorized',
    DETAILS: 'Error when trying to log in, the credentials are not valid.',
  },
  DEFAULT: {
    TITLE: 'User not authorized',
    DETAILS: 'Please verify your username (phone) and password.',
  },
};

export const errorMap = {
  [AuthErrorNames.NotAuthorizedException]: TOAST.NOT_AUTHORIZED,
  [AuthErrorNames.EmptySignInPassword]: TOAST.EmptySignInPassword,
};

export const defaultToast = TOAST.DEFAULT;
